export const ISSUE_PHOTO_MAX_COUNT = 5;
export const ISSUE_PHOTO_MAX_BYTES = 2 * 1024 * 1024;
export const ISSUE_PHOTO_MAX_DIMENSION = 2048;
